import { gql } from 'sccs-shared-apollo-client-v0';
import {
  DATE_RANGE_FACET,
  FORMATTED_VALUE_FACET,
  INTEGER_TECHNICAL_DATA,
  POWER_DATA,
  RANGE_FACET,
  SIMPLE_COUNT_FACET,
  TECHNICAL_DATA,
} from './fragments';

export const GET_SEARCH_RESULTS = gql`
  query GetSearchResults(
    $baumuster4: String
    $bodyType: [BodyType!]
    $brand: [String!]
    $campaigns: [String!]
    $contextType: ContextType! = B2C
    $fuelType: [FuelTypeHarmonized!]
    $language: String
    $lines: [String!]
    $limit: Int! = 10
    $modelIdentifier: [VehicleClass!]
    $page: Int! = 0
    $productionDate: DateRange
    $profileId: String!
    $sortingType: String! = "price-asc"
    $typeClass: [String!]
    $vehicleCategory: String!
  ) {
    search(
      baumuster4: $baumuster4
      bodyType: $bodyType
      brand: $brand
      campaigns: $campaigns
      contextType: $contextType
      fuelType: $fuelType
      language: $language
      lines: $lines
      limit: $limit
      modelIdentifier: $modelIdentifier
      page: $page
      productionDate: $productionDate
      profileId: $profileId
      sortingType: $sortingType
      typeClass: $typeClass
      vehicleCategory: $vehicleCategory
    ) {
      facets {
        bodyType {
          ...FormattedValueFacetFragment
        }
        brand {
          ...FormattedValueFacetFragment
        }
        buildType {
          ...SimpleCountFacetFragment
        }
        campaigns {
          ...FormattedValueFacetFragment
        }
        color {
          ...FormattedValueFacetFragment
        }
        colorName {
          ...FormattedValueFacetFragment
        }
        colorPolish {
          ...FormattedValueFacetFragment
        }
        dealerId {
          ...SimpleCountFacetFragment
        }
        driveType {
          ...FormattedValueFacetFragment
        }
        enginePowerHP {
          ...RangeFacetFragment
        }
        enginePowerKW {
          ...RangeFacetFragment
        }
        equipment {
          ...FormattedValueFacetFragment
        }
        estimatedArrivalDate {
          ...DateRangeFacetFragment
        }
        fuelType {
          ...FormattedValueFacetFragment
        }
        gearbox {
          ...FormattedValueFacetFragment
        }
        generation {
          ...SimpleCountFacetFragment
        }
        lines {
          ...FormattedValueFacetFragment
        }
        modelIdentifier {
          ...FormattedValueFacetFragment
        }
        modelYear {
          ...RangeFacetFragment
        }
        monthlyRate {
          ...RangeFacetFragment
        }
        motorization {
          ...SimpleCountFacetFragment
        }
        packages {
          ...FormattedValueFacetFragment
        }
        price {
          ...RangeFacetFragment
        }
        productionDate {
          ...DateRangeFacetFragment
        }
        stockType {
          ...SimpleCountFacetFragment
        }
        upholstery {
          ...FormattedValueFacetFragment
        }
        upholsteryName {
          ...FormattedValueFacetFragment
        }
        upholsteryPolish {
          ...FormattedValueFacetFragment
        }
      }
      navigation {
        currentLimit
        currentPage
        currentSortingCode
        totalPages
        totalResults
      }
      results {
        characteristics {
          highlights {
            label
          }
          campaigns {
            description
            footnote
            label
          }
        }
        pdpLink
        srpLink
        emissionAndConsumption {
          attributes {
            displayValue
            id
            label
            mustShowIn
            unit
            value
          }
          footnotes
          testProcedure
        }
        envkv {
          co2Classes {
            primary
            secondary
          }
        }
        estimatedArrivalDate
        identification {
          code
          commissionNumber
          dcpProductType
        }
        images {
          default
        }
        productionDate
        technicalInformation {
          engine {
            fuelType {
              ...TechData
            }
            power {
              ...PowerDataFragment
            }
          }
          transmission {
            ...TechData
          }
        }
        vehicleModel {
          baumuster
          bodyType {
            ...TechData
          }
          brand {
            ...TechData
          }
          category {
            ...TechData
          }
          name
          steeringPosition {
            ...TechData
          }
          typeClass
          vehicleClass {
            ...TechData
          }
        }
      }
    }
  }
  ${TECHNICAL_DATA}
  ${DATE_RANGE_FACET}
  ${FORMATTED_VALUE_FACET}
  ${INTEGER_TECHNICAL_DATA}
  ${POWER_DATA}
  ${RANGE_FACET}
  ${SIMPLE_COUNT_FACET}
`;

export const GET_FACETS = gql`
  query GetFacets($language: String, $profileId: String!, $vehicleCategory: String!) {
    search(language: $language, profileId: $profileId, vehicleCategory: $vehicleCategory) {
      facets {
        bodyType {
          ...FormattedValueFacetFragment
        }
        brand {
          ...FormattedValueFacetFragment
        }
        buildType {
          ...SimpleCountFacetFragment
        }
        campaigns {
          ...FormattedValueFacetFragment
        }
        color {
          ...FormattedValueFacetFragment
        }
        colorName {
          ...FormattedValueFacetFragment
        }
        colorPolish {
          ...FormattedValueFacetFragment
        }
        dealerId {
          ...SimpleCountFacetFragment
        }
        driveType {
          ...FormattedValueFacetFragment
        }
        enginePowerHP {
          ...RangeFacetFragment
        }
        enginePowerKW {
          ...RangeFacetFragment
        }
        equipment {
          ...FormattedValueFacetFragment
        }
        estimatedArrivalDate {
          ...DateRangeFacetFragment
        }
        fuelType {
          ...FormattedValueFacetFragment
        }
        gearbox {
          ...FormattedValueFacetFragment
        }
        generation {
          ...SimpleCountFacetFragment
        }
        lines {
          ...FormattedValueFacetFragment
        }
        modelIdentifier {
          ...FormattedValueFacetFragment
        }
        modelYear {
          ...RangeFacetFragment
        }
        monthlyRate {
          ...RangeFacetFragment
        }
        motorization {
          ...SimpleCountFacetFragment
        }
        packages {
          ...FormattedValueFacetFragment
        }
        price {
          ...RangeFacetFragment
        }
        productionDate {
          ...DateRangeFacetFragment
        }
        stockType {
          ...SimpleCountFacetFragment
        }
        upholstery {
          ...FormattedValueFacetFragment
        }
        upholsteryName {
          ...FormattedValueFacetFragment
        }
        upholsteryPolish {
          ...FormattedValueFacetFragment
        }
      }
    }
  }
  ${DATE_RANGE_FACET}
  ${FORMATTED_VALUE_FACET}
  ${RANGE_FACET}
  ${SIMPLE_COUNT_FACET}
`;
